import { DOCUMENT } from '@angular/common';
import { ChangeDetectionStrategy, Component, effect, inject } from '@angular/core';
import { ThemeService } from './core/services/theme.service';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.html',
  styleUrl: './app.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class App {
  private readonly _document = inject(DOCUMENT);
  private readonly _themeService = inject(ThemeService);

  protected readonly theme = this._themeService.theme;
  private readonly _applyThemeToBodyEffect = effect(() => {
    const body = this._document?.body;

    if (!body) {
      return;
    }

    body.setAttribute('data-theme', this.theme());
  });
}
